import axios from 'axios'
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_SAVE_AND_EMAIL_BEGIN,
  MANAGE_SUBS_SAVE_AND_EMAIL_SUCCESS,
  MANAGE_SUBS_SAVE_AND_EMAIL_FAILURE,
  MANAGE_SUBS_SAVE_AND_EMAIL_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';

export function saveAndEmail(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_SAVE_AND_EMAIL_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/saveAndEmail`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_SAVE_AND_EMAIL_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_SAVE_AND_EMAIL_FAILURE,
            data: { error: errorMsg },
          });
          reject(errorMsg);
        },
      );
    });

    return promise;
  };
}

export function dismissSaveAndEmailError() {
  return {
    type: MANAGE_SUBS_SAVE_AND_EMAIL_DISMISS_ERROR,
  };
}

export function useSaveAndEmail() {
  const dispatch = useDispatch();

  const { saveAndEmailPending, saveAndEmailError } = useSelector(
    state => ({
      saveAndEmailPending: state.manageSubs.saveAndEmailPending,
      saveAndEmailError: state.manageSubs.saveAndEmailError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(saveAndEmail(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissSaveAndEmailError());
  }, [dispatch]);

  return {
    saveAndEmail: boundAction,
    saveAndEmailPending,
    saveAndEmailError,
    dismissSaveAndEmailError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_SAVE_AND_EMAIL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        saveAndEmailPending: true,
        saveAndEmailError: null,
      };

    case MANAGE_SUBS_SAVE_AND_EMAIL_SUCCESS:
      // The request is success
      return {
        ...state,
        saveAndEmailPending: false,
        saveAndEmailError: null,
      };

    case MANAGE_SUBS_SAVE_AND_EMAIL_FAILURE:
      // The request is failed
      return {
        ...state,
        saveAndEmailPending: false,
        saveAndEmailError: action.data.error,
      };

    case MANAGE_SUBS_SAVE_AND_EMAIL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        saveAndEmailError: null,
      };

    default:
      return state;
  }
}
